import { createSlice } from "@reduxjs/toolkit";
import {
  AddCurrencyAction,
  DeleteCurrencyAction,
  GetAllCurrencyAction,
  UpdateCurrencyAction,
} from "store/middlewares/dataManagement/currency";

// isDeleteMeFulFilled
export const currencySlice = createSlice({
  name: "currency",
  initialState: {
    currencyLoading: true,
    currency: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllCurrencyAction.pending, (state) => {
        // state.currencyLoading = true;
        // state.currency = null;
        state.currency =
          state.currency?.data?.length > 0 ? state.currency : null;
      })
      .addCase(GetAllCurrencyAction.fulfilled, (state, action) => {
        state.currencyLoading = false;
        state.currency = action.payload.response;
      })
      .addCase(GetAllCurrencyAction.rejected, (state) => {
        state.currencyLoading = false;
        state.currency = null;
      })

      // Delete
      .addCase(DeleteCurrencyAction.fulfilled, (state, action) => {
        state.currencyLoading = false;
        state.currency = action.payload.response;
      })

      //Update
      .addCase(UpdateCurrencyAction.fulfilled, (state, action) => {
        state.currencyLoading = false;
        state.currency = {
          ...state.currency,
          data: state.currency.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddCurrencyAction.fulfilled, (state, action) => {
        state.currencyLoading = false;
        state.currency = action.payload.response;
      });
  },
});

export default currencySlice.reducer;
